import AccountSettings from "./account_settings";

export default AccountSettings;
